import { Pipe, PipeTransform } from '@angular/core';
import { Izolacja } from './ankieta';

@Pipe({
  name: 'izolacja'
})
export class IzolacjaPipe implements PipeTransform {

  transform(value: Izolacja, args?: any): any {
    if (value == Izolacja.styropian) {
      return "styropian";
    }
    else {
      return "wełna mineralna";
    }
  }

}
